import { useQuery } from '@apollo/client';

import { GET_CUSTOM_SKILL_SHARES, type CustomSkillRecord } from '../../../queries/chats';
import { GET_CUSTOM_SKILL_GROUP_SHARES } from '../../../queries/skill-group-sharing';

type ShareableCustomSkill = Pick<CustomSkillRecord, 'draftOfCustomSkillUuid' | 'uuid'>;

export function useCustomSkillShareStatus(skill?: ShareableCustomSkill | null) {
  const rootSkillUuid = skill?.draftOfCustomSkillUuid ?? skill?.uuid;
  const { data, error, loading } = useQuery(GET_CUSTOM_SKILL_SHARES, {
    variables: { filters: { customSkillUuids: rootSkillUuid ? [rootSkillUuid] : [] } },
    skip: !rootSkillUuid,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });
  const groupShares = useQuery(GET_CUSTOM_SKILL_GROUP_SHARES, {
    variables: { skillUuid: rootSkillUuid ?? '' },
    skip: !rootSkillUuid,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  return {
    error: error ?? groupShares.error,
    hasShares: Boolean(
      data?.customSkillShares?.length || groupShares.data?.getCustomSkillGroupAssignments.groups.length,
    ),
    isResolved:
      !rootSkillUuid ||
      (!loading &&
        !groupShares.loading &&
        !error &&
        !groupShares.error &&
        Boolean(data?.customSkillShares) &&
        Boolean(groupShares.data?.getCustomSkillGroupAssignments)),
  };
}
